import React, { ReactNode } from 'react'
import { Spinner } from '@web/walter-ui-kit'

import Pending from '../Pending'
import Rejected from '../Rejected'
import Start from '../Start/index'
import { useData } from '../../useData'
import styles from '../../style.module.css'
import { Content } from './Content'
import SumSub from '~modals/SettingsModal/SumSub'
import { KycStatuses } from '~modals/SettingsModal/tabs/Identity/Level'

interface Props {
    isSumSubOpen: boolean
    setSumSubOpen: (isOpen: boolean) => void
}

function StartMigration({ setSumSubOpen, isSumSubOpen }: Props) {
    const { isTokenLoading, isLoading, token, nextLevel, status, requestKycStatus, onApplicantSubmit } = useData({
        onSuccess: () => setSumSubOpen(true),
    })

    let content: ReactNode

    const isShowSumsub = () => {
        if (!isSumSubOpen) {
            return false
        }
        if (token && nextLevel) {
            return true
        }

        return false
    }

    if (isLoading) {
        content = (
            <div className={styles.spinner}>
                <Spinner size={30} />
            </div>
        )
    } else if (isShowSumsub()) {
        const onSubmit = async () => {
            await onApplicantSubmit()
            setSumSubOpen(false)
        }

        content = (
            <SumSub
                token={token}
                nextLevel={nextLevel}
                onApplicantSubmit={onSubmit}
                helpersClassname={styles.helperContainer}
            />
        )
    } else if (status === KycStatuses.pending) {
        content = <Pending />
    } else if (status === KycStatuses.rejected) {
        content = <Rejected />
    } else {
        content = <Start onNext={requestKycStatus} isTokenLoading={isTokenLoading} />
    }

    return <Content content={content} isLoading={isLoading} isShowSumSub={isShowSumsub()} />
}

export default StartMigration
